import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Loading from '../../Loading';
import { CloseIcon } from '../../../components/CommonIcons';
import * as styles from '../Modal.scss';

/**
 * Reusable ModalBody Component -- Captures clickOutside Events w/ Ref
 * @class ModalBody
 * @property {Object} state
 * @property {Object} contentRef
 */
export default class ModalBody extends Component {
  static propTypes = {
    clickOutsideFn: PropTypes.func.isRequired,
    showCloseButton: PropTypes.bool.isRequired,
    className: PropTypes.string,
    disableClickOutside: PropTypes.bool,
    loading: PropTypes.bool,
    loadingClassName: PropTypes.string,
    loadingMessage: PropTypes.string,
    style: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
    ),
  };

  static defaultProps = {
    className: null,
    disableClickOutside: false,
    loading: false,
    loadingClassName: null,
    style: null,
  };

  constructor(props) {
    super(props);
    this.contentRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Handles clickOutside Modal Hiding Unless ClickOutside is Disabled
   * @param {Object} e - Event Object
   * @return {Function} return this.props.clickOutsideFn()
   */
  handleClickOutside = e => {
    const { disableClickOutside, clickOutsideFn } = this.props;

    if (this.contentRef && !this.contentRef.current.contains(e.target) && !disableClickOutside) return clickOutsideFn();
    return null;
  }

  renderLoading = () => {
    const { loadingClassName, loadingMessage } = this.props;

    return (
      <div className={classNames(styles.loading, loadingClassName)}>
        <Loading className={styles.loadingComponent} text={loadingMessage} />
      </div>
    );
  }

  render() {
    const {
      children,
      className,
      clickOutsideFn,
      loading,
      showCloseButton,
      style,
    } = this.props;

    return (
      <div
        className={classNames(styles.modalContent, className)}
        style={style}
        ref={this.contentRef}
      >
        {showCloseButton &&
          <div className={styles.closeIcon} onClick={clickOutsideFn}>
            <CloseIcon />
          </div>}
        {loading && this.renderLoading()}
        {!loading && children}
      </div>
    );
  }
}
